import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import React, { useEffect, useRef, useState } from "react";
import "./Blogs.css";
import { BASEURL } from "../../../constant/constant";
// ...other imports

export default function BlogPage() {
  const [currentIndexs, setCurrentIndexs] = useState(0);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  const totalSlides = 2;
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexs((prevIndex) => (prevIndex + 1) % totalSlides);
    }, 3000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const fetchBlogs = async () => {
    try {
      const res = await fetch(`${BASEURL}/api/blog/getblog`, {
        method: "GET",
        redirect: "follow",
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      const json = await res.json();
      if (json.success && Array.isArray(json.data)) {
        setBlogs(json.data);
      } else {
        setBlogs([]);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load blogs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    fetchBlogs();
    hasFetched.current = true;
  }, []);


  const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const featuredb = blogs[0];
  const latestPosts = blogs.slice(1);

  // SEO: only from FIRST blog
  const pageTitle =
    featuredb?.seo?.meta_title || "Our Blog - sandip electronics  And Automation";
  const pageDesc =
    featuredb?.seo?.meta_description ||
    "Read the latest updates and articles from sandip electronics  And Automation.";

  return (
    <div className="page-blog">
      <Helmet>
        <title>Automation & Solar Insights Blog | Sandip electronics  and Automation</title>
        <meta name="description" content="Stay updated with the latest in solar pump technology, automatic transfer switches (ATS), and industrial IoT. Expert guides from Sandip electronics  and Automation." />
        <meta name="keywords" content="automation blog, solar pump controller tips, ATS installation guide, industrial IoT India, Sandip electronics  news" />
        <meta property="og:title" content="Expert Automation & Solar Energy Blog" />
        <meta property="og:description" content="Technical guides, industry trends, and innovation updates from the experts at Sandip electronics  and Automation." />
        <meta property="og:image" content="https://seaiot.in/images/blog-thumbnail.jpg" />
        <meta property="og:url" content="https://seaiot.in/blogPage" />
        <meta property="og:type" content="blog" />
      </Helmet>

      <div className="blog-card">
        {loading && <p>Loading blogs...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {/* featuredb */}
        {!loading && featuredb && (
          <div className="featuredb">
            <div className="featuredb-left">
              <h1 className="page-title">Our Blog</h1>
              <div className="meta-row">
                <span className="meta-icon">🕒</span>
                <span className="meta-text">
                  {formatDate(featuredb.published_at)}
                </span>
              </div>

              <h2 className="featuredb-title">
                {featuredb.title}
              </h2>

              <p className="featuredb-desc">
                {featuredb.excerpt || featuredb.seo?.meta_description}
              </p>

              <Link
                to={`/BlogDetail/${featuredb._id}`}
                className="btn-primary btn-link"
              >
                Read More
              </Link>
            </div>

            <div className="featuredb-right">
              <img
                src={`${BASEURL}${featuredb.cover_image}`}
                alt={featuredb.title}
                className="featuredb-image"
              />
            </div>
          </div>
        )}

        {/* LATEST POSTS */}
        {!loading && latestPosts.length > 0 && (
          <section className="latest-section">
            <h3 className="latest-title">Latest Posts</h3>
            <div className="latest-list">
              {latestPosts.map((post) => (
                <article key={post._id} className="post-card">
                  <img
                    src={
                       `${BASEURL}${post.cover_image}`
                    }
                    alt={post.title}
                    className="post-image"
                  />
                  <div className="post-body">
                    <h4 className="post-title">
                      {post.title}
                    </h4>
                    <div className="post-meta">
                      <span className="meta-icon">🕒</span>
                      <span className="meta-text">
                        {formatDate(post.published_at)}
                      </span>
                    </div>
                    <Link
                      to={`/BlogDetail/${post._id}`}
                      className="post-readmore-link"
                    >
                      Read More →
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
